import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ICampaignsResponse } from "../../features/Campaigns/interface";
import { useAuth } from "../helper/useAuth";
import dayjs from "dayjs";

interface UseCampaignsParams {
  startDate?: Date;
  endDate?: Date;
  search?: string;
  status?: string;
  page?: number;
  per_page?: number;
  sort_by?: string;
  sort_order?: "asc" | "desc";
}

export const useCampaigns = (params?: UseCampaignsParams) => {
  const { selectedIntegration } = useAuth();
  const startDate = params?.startDate;
  const endDate = params?.endDate;
  const search = params?.search;
  const status = params?.status;
  const page = params?.page || 1;
  const per_page = params?.per_page || 10;
  const sort_by = params?.sort_by;
  const sort_order = params?.sort_order;

  return useQuery<ICampaignsResponse, Error>({
    queryKey: [
      "campaigns",
      startDate?.toISOString(),
      endDate?.toISOString(),
      search,
      status,
      page,
      per_page,
      sort_by,
      sort_order,
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      return httpService.get<ICampaignsResponse>(API_CONFIG.path.googleAdsCampaignList, {
        page,
        per_page,
        tracking_id: selectedIntegration?.value as string,
        ...(startDate && { start_date: dayjs(startDate).format("YYYY-MM-DD") }),
        ...(endDate && { end_date: dayjs(endDate).format("YYYY-MM-DD") }),
        ...(search && { search }),
        ...(status && { status }),
        ...(sort_by && { sort_by }),
        ...(sort_order && { sort_order }),
      });
    },
    enabled: !!selectedIntegration?.value,
    placeholderData: (previousData) => previousData,
  });
};
